export default __webpack_public_path__ + "static/media/BRIK_logo_black_2.e9e00814.svg";